import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "./store";

interface mode{
    lightMode:boolean
}

const initialState:mode={
    lightMode:true
}
export const modeReducer=createSlice({
    name:'mode',
    initialState,
    reducers:{
        light:(state)=>{state.lightMode=true},
        dark:(state)=>{state.lightMode=false},
    }
});

export const {light,dark}=modeReducer.actions;
export const selectCount = (state: RootState) => state.mode.lightMode
export default modeReducer.reducer; 